module.exports = __webpack_public_path__ + "static/fonts/iconfont.74d89687.woff2";